/** Full-screen loading indicator with an optional German label. */
export function Spinner({ label }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white text-slate-600 dark:bg-slate-950 dark:text-slate-400"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-sky-600 dark:border-slate-700 dark:border-t-sky-500" />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}
